var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "floor-plan-container" },
    [
      _c("img", {
        ref: "floorPlanImage",
        staticClass: "floor-plan-image",
        attrs: {
          src: _vm.floorPlan.image_url,
          alt: _vm.floorPlan.name,
          crossorigin: "anonymous",
        },
        on: { load: _vm.onImageLoad },
      }),
      _vm._v(" "),
      _vm.hasNoPlacedTraps
        ? _c(
            "div",
            { staticClass: "placement-hint-overlay" },
            [
              _c(
                "v-card",
                {
                  staticClass: "placement-hint-card",
                  attrs: { elevation: "3" },
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mb-2", attrs: { large: "" } },
                        [_vm._v("mdi-information-outline")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-h6 mb-2" }, [
                        _vm._v(_vm._s(_vm.$t("placement_hint.title"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-body-2" }, [
                        _vm._v(_vm._s(_vm.$t("placement_hint.description"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("canvas", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isHeatmapMode,
            expression: "isHeatmapMode",
          },
        ],
        ref: "heatmapCanvas",
        staticClass: "heatmap-overlay",
        attrs: { "data-testid": "heatmap-canvas" },
      }),
      _vm._v(" "),
      _c(
        "svg",
        {
          ref: "svgOverlay",
          staticClass: "overlay",
          attrs: {
            role: "img",
            "aria-label": _vm.$t("floor_plan_canvas"),
            viewBox: _vm.viewBox,
            preserveAspectRatio: "xMinYMin meet",
          },
          on: {
            dragover: function ($event) {
              $event.preventDefault()
            },
            drop: _vm.handleDrop,
            mousemove: _vm.handleMouseMove,
            mouseup: _vm.handleMouseUp,
          },
        },
        [
          _vm._l(_vm.placedTraps, function (trap) {
            return _c(
              "g",
              {
                key: trap.trapNo,
                staticClass: "trap-group",
                attrs: { "data-testid": "trap-group-" + trap.trapNo },
                on: {
                  mouseenter: function ($event) {
                    return _vm.handleTrapMouseEnter($event, trap)
                  },
                  mouseleave: _vm.handleTrapMouseLeave,
                },
              },
              [
                trap.count > 0 && _vm.isCircleVisible
                  ? _c("circle", {
                      staticClass: "trap-circle trap-circle--current",
                      attrs: {
                        cx: trap.coordinates.x,
                        cy: trap.coordinates.y,
                        r: _vm.calculateCircleRadius(trap.count),
                        fill: "rgba(204, 0, 0, 0.5)",
                        "aria-label": _vm.$t("trap_label", {
                          trapNo: trap.trapNo,
                        }),
                      },
                      on: {
                        mousedown: function ($event) {
                          return _vm.handleMouseDown($event, trap.trapNo)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isHeatmapMode
                  ? _c("circle", {
                      staticClass: "trap-circle",
                      attrs: {
                        cx: trap.coordinates.x,
                        cy: trap.coordinates.y,
                        r: _vm.markerSize * 1.5,
                        fill: "transparent",
                      },
                      on: {
                        mousedown: function ($event) {
                          return _vm.handleMouseDown($event, trap.trapNo)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("rect", {
                  class: [
                    "trap-marker",
                    { "trap-marker--heatmap": _vm.isHeatmapMode },
                  ],
                  attrs: {
                    x: trap.coordinates.x - _vm.markerSize / 2,
                    y: trap.coordinates.y - _vm.markerSize / 2,
                    width: _vm.markerSize,
                    height: _vm.markerSize,
                    fill: "#FFD700",
                    stroke: "black",
                    "stroke-width": _vm.strokeWidth,
                    "aria-label": _vm.$t("trap_marker", {
                      trapNo: trap.trapNo,
                    }),
                  },
                  on: {
                    mousedown: function ($event) {
                      return _vm.handleMouseDown($event, trap.trapNo)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.labelDisplayMode !== _vm.DISPLAY_MODES.NONE
                  ? _c(
                      "text",
                      {
                        staticClass: "trap-label",
                        attrs: {
                          x: _vm.getLabelX(trap),
                          y: trap.coordinates.y,
                        },
                      },
                      [
                        _vm.labelDisplayMode === _vm.DISPLAY_MODES.NAME
                          ? [
                              _c(
                                "tspan",
                                {
                                  staticClass: "trap-label-name",
                                  attrs: {
                                    "font-size": 18 * _vm.sizeScale,
                                    "stroke-width": 3 * _vm.sizeScale,
                                    stroke: "white",
                                    fill: "#333",
                                    "paint-order": "stroke fill",
                                    "dominant-baseline": "middle",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.getTrapName(trap)) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          : _vm.labelDisplayMode ===
                            _vm.DISPLAY_MODES.NAME_AND_COUNT
                          ? [
                              _c(
                                "tspan",
                                {
                                  staticClass: "trap-label-name",
                                  attrs: {
                                    x: _vm.getLabelX(trap),
                                    dy: -6 * _vm.sizeScale,
                                    "font-size": 18 * _vm.sizeScale,
                                    "stroke-width": 3 * _vm.sizeScale,
                                    stroke: "white",
                                    fill: "#333",
                                    "paint-order": "stroke fill",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.getTrapName(trap)) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "tspan",
                                {
                                  staticClass: "trap-label-count",
                                  attrs: {
                                    x: _vm.getLabelX(trap),
                                    dy: 14 * _vm.sizeScale,
                                    "font-size": 14 * _vm.sizeScale,
                                    "stroke-width": 4 * _vm.sizeScale,
                                    stroke: "white",
                                    "font-weight": "500",
                                    fill: "#444",
                                    "paint-order": "stroke fill",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            (" +
                                      _vm._s(_vm.getCountDisplay(trap)) +
                                      ")\n          "
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          _vm.isHeatmapMode
            ? _c(
                "g",
                {
                  staticClass: "heatmap-legend",
                  attrs: { "data-testid": "heatmap-legend" },
                },
                [
                  _c(
                    "defs",
                    [
                      _c(
                        "linearGradient",
                        { attrs: { id: "heatGradient" } },
                        [
                          _c("stop", {
                            attrs: {
                              offset: "0%",
                              "stop-color": "rgb(0,0,255)",
                            },
                          }),
                          _vm._v(" "),
                          _c("stop", {
                            attrs: {
                              offset: "25%",
                              "stop-color": "rgb(0,255,0)",
                            },
                          }),
                          _vm._v(" "),
                          _c("stop", {
                            attrs: {
                              offset: "50%",
                              "stop-color": "rgb(255,255,0)",
                            },
                          }),
                          _vm._v(" "),
                          _c("stop", {
                            attrs: {
                              offset: "100%",
                              "stop-color": "rgb(255,0,0)",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "linearGradient",
                        { attrs: { id: "comparisonGradient" } },
                        [
                          _c("stop", {
                            attrs: {
                              offset: "0%",
                              "stop-color": "rgb(49,54,149)",
                            },
                          }),
                          _vm._v(" "),
                          _c("stop", {
                            attrs: {
                              offset: "25%",
                              "stop-color": "rgb(145,191,219)",
                            },
                          }),
                          _vm._v(" "),
                          _c("stop", {
                            attrs: {
                              offset: "50%",
                              "stop-color": "rgb(255,255,255)",
                            },
                          }),
                          _vm._v(" "),
                          _c("stop", {
                            attrs: {
                              offset: "75%",
                              "stop-color": "rgb(223,136,104)",
                            },
                          }),
                          _vm._v(" "),
                          _c("stop", {
                            attrs: {
                              offset: "100%",
                              "stop-color": "rgb(180,4,38)",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: _vm.legendX - 8 * _vm.sizeScale,
                      y: _vm.legendY - 4 * _vm.sizeScale,
                      width: _vm.legendBarWidth + 16 * _vm.sizeScale,
                      height: _vm.legendBarHeight + 32 * _vm.sizeScale,
                      rx: 4 * _vm.sizeScale,
                      fill: "rgba(255,255,255,0.85)",
                      stroke: "#ccc",
                      "stroke-width": _vm.sizeScale,
                    },
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      x: _vm.legendX,
                      y: _vm.legendY,
                      width: _vm.legendBarWidth,
                      height: _vm.legendBarHeight,
                      fill:
                        _vm.displayMode === _vm.DISPLAY_MODES.COMPARISON_HEAT
                          ? "url(#comparisonGradient)"
                          : "url(#heatGradient)",
                      stroke: "#999",
                      "stroke-width": _vm.sizeScale * 0.5,
                    },
                  }),
                  _vm._v(" "),
                  _vm.displayMode === _vm.DISPLAY_MODES.HEAT
                    ? [
                        _c(
                          "text",
                          {
                            attrs: {
                              x: _vm.legendX,
                              y:
                                _vm.legendY +
                                _vm.legendBarHeight +
                                14 * _vm.sizeScale,
                              "font-size": 14 * _vm.sizeScale,
                              "stroke-width": 3 * _vm.sizeScale,
                              stroke: "white",
                              fill: "#333",
                              "font-family": "sans-serif",
                              "font-weight": "bold",
                              "paint-order": "stroke fill",
                              "text-anchor": "start",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("legend.low")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            attrs: {
                              x: _vm.legendX + _vm.legendBarWidth,
                              y:
                                _vm.legendY +
                                _vm.legendBarHeight +
                                14 * _vm.sizeScale,
                              "font-size": 14 * _vm.sizeScale,
                              "stroke-width": 3 * _vm.sizeScale,
                              stroke: "white",
                              fill: "#333",
                              "font-family": "sans-serif",
                              "font-weight": "bold",
                              "paint-order": "stroke fill",
                              "text-anchor": "end",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("legend.high")))]
                        ),
                      ]
                    : [
                        _c(
                          "text",
                          {
                            attrs: {
                              x: _vm.legendX,
                              y:
                                _vm.legendY +
                                _vm.legendBarHeight +
                                14 * _vm.sizeScale,
                              "font-size": 14 * _vm.sizeScale,
                              "stroke-width": 3 * _vm.sizeScale,
                              stroke: "white",
                              fill: "#333",
                              "font-family": "sans-serif",
                              "font-weight": "bold",
                              "paint-order": "stroke fill",
                              "text-anchor": "start",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("legend.decrease")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            attrs: {
                              x: _vm.legendX + _vm.legendBarWidth / 2,
                              y:
                                _vm.legendY +
                                _vm.legendBarHeight +
                                14 * _vm.sizeScale,
                              "font-size": 14 * _vm.sizeScale,
                              "stroke-width": 3 * _vm.sizeScale,
                              stroke: "white",
                              fill: "#333",
                              "font-family": "sans-serif",
                              "font-weight": "bold",
                              "paint-order": "stroke fill",
                              "text-anchor": "middle",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("legend.no_change")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            attrs: {
                              x: _vm.legendX + _vm.legendBarWidth,
                              y:
                                _vm.legendY +
                                _vm.legendBarHeight +
                                14 * _vm.sizeScale,
                              "font-size": 14 * _vm.sizeScale,
                              "stroke-width": 3 * _vm.sizeScale,
                              stroke: "white",
                              fill: "#333",
                              "font-family": "sans-serif",
                              "font-weight": "bold",
                              "paint-order": "stroke fill",
                              "text-anchor": "end",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("legend.increase")))]
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.exportInfoLines.length
            ? _c(
                "g",
                {
                  staticClass: "export-info",
                  attrs: { "data-testid": "export-info" },
                },
                _vm._l(_vm.exportInfoLines, function (line, index) {
                  return _c(
                    "text",
                    {
                      key: index,
                      staticClass: "export-info-text",
                      attrs: {
                        x: 10 * _vm.sizeScale,
                        y: (20 + index * 20) * _vm.sizeScale,
                        "font-size": 14 * _vm.sizeScale,
                        "stroke-width": 3 * _vm.sizeScale,
                        stroke: "white",
                        fill: "#333",
                        "font-family": "sans-serif",
                        "font-weight": "bold",
                        "paint-order": "stroke fill",
                      },
                    },
                    [_vm._v("\n        " + _vm._s(line) + "\n      ")]
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("PieChartPopup", {
        attrs: {
          trap: _vm.hoveredTrap,
          "position-x": _vm.popupPosition.x,
          "position-y": _vm.popupPosition.y,
        },
        model: {
          value: _vm.showPopup,
          callback: function ($$v) {
            _vm.showPopup = $$v
          },
          expression: "showPopup",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }